<app-floorplan-product-menu
  [title]="tooltipTextAlarmDevices"
  [hasConfigurations]="alarmDevices.length > 0"
  [visible]="floorplan.floorplanState.alarmDevicesVisible"
  [locked]="floorplan.floorplanState.alarmDevicesLocked"
  [itemTextVisible]="floorplan.floorplanState.alarmDevicesItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.alarmDevicesVisible = $event"
  (lockUpdate)="floorplan.floorplanState.alarmDevicesLocked = $event"
  (itemTextVisibilityUpdate)="updateAlarmDevicesItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="alarm-device"
>
  @for (alarmDevice of alarmDevices; track alarmDevice) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="alarmDevice"
        [numberOfFloorplanItems]="floorplan.countPlacedAlarmDevices(alarmDevice)"
        [attachments]="alarmDevice.attachments"
        (add)="addAlarmDevice(alarmDevice)"
        (delete)="deleteAlarmDevice(alarmDevice)"
        (dragStart)="drag(alarmDevice)"
        editPath="alarm-device"
        imageUrl="./assets/icons-blue/alarmmittel_blau.svg"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
